import React, { Component } from 'react';
import './Loader.css';

class Loader extends Component {
    render() {
        return ( 
            <div className="loader">
                <div className="loader-image"></div>
            </div>
        );
    }
}

export default Loader;


// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js